import React from 'react';
import { ICustomerEditorFormModel } from '../../form-services/customer-editor-iface';
import { BwjGrid, Row, Col } from '../../../../framework/components/bwj-layout';
import { Spacing } from '../../../../framework/components/bwj-layout/styles';
import { BwjTextField } from '../../../../framework/components/bwj-text-field';
import * as formService from '../../form-services/customer-editor';
import { BwjLabelField } from '../../../../framework/components/bwj-label-field';

interface ICustomerEditorProps {
  formModel: ICustomerEditorFormModel;
}

export const CustomerEditor: React.FunctionComponent<ICustomerEditorProps> = (props) => {
  const { formModel } = props;

  return (
    <BwjGrid>
      <Row bottomSpacing={Spacing.Large}>
        <Col small={12} large={8}>
          <BwjTextField
            id={formService.name.id}
            required={true}
            label={formService.name.description}
            onUpdate={formService.name.onUpdate}
            input={formModel.name}
          />
        </Col>
        <Col small={12} large={4}>
          <BwjTextField
            id={formService.firstName.id}
            required={true}
            label={formService.firstName.description}
            onUpdate={formService.firstName.onUpdate}
            input={formModel.firstName}
          />
        </Col>
      </Row>
      <Row bottomSpacing={Spacing.Large}>
        <Col small={3} large={2}>
          <BwjLabelField
            id={formService.houseNumber.id}
            label={formService.houseNumber.description}
            value={formModel.houseNumber}
          />
        </Col>
        <Col small={9} large={10}>
          <BwjTextField
            id={formService.streetName.id}
            required={true}
            label={formService.streetName.description}
            onUpdate={formService.streetName.onUpdate}
            input={formModel.streetName}
          />
        </Col>
      </Row>
      <Row bottomSpacing={Spacing.Large}>
        <Col small={12} large={9}>
          <BwjTextField
            id={formService.city.id}
            required={true}
            label={formService.city.description}
            onUpdate={formService.city.onUpdate}
            input={formModel.city}
          />
        </Col>
        <Col small={12} large={3}>
          <BwjTextField
            id={formService.zipCode.id}
            required={true}
            label={formService.zipCode.description}
            onUpdate={formService.zipCode.onUpdate}
            input={formModel.zipCode}
          />
        </Col>
      </Row>
      <Row bottomSpacing={Spacing.Large}>
        <Col small={12} large={6}>
          <BwjTextField
            id={formService.email.id}
            required={true}
            label={formService.email.description}
            onUpdate={formService.email.onUpdate}
            input={formModel.email}
          />
        </Col>
        <Col small={12} large={3}>
          <BwjTextField
            id={formService.phonePrimary.id}
            required={true}
            label={formService.phonePrimary.description}
            onUpdate={formService.phonePrimary.onUpdate}
            input={formModel.phonePrimary}
          />
        </Col>
        <Col small={12} large={3}>
          <BwjTextField
            id={formService.phoneSecondary.id}
            required={false}
            label={formService.phoneSecondary.description}
            onUpdate={formService.phoneSecondary.onUpdate}
            input={formModel.phoneSecondary}
          />
        </Col>
      </Row>
      <Row bottomSpacing={Spacing.Large}>
        <Col small={12}>
          <BwjTextField
            id={formService.notes.id}
            required={false}
            label={formService.notes.description}
            onUpdate={formService.notes.onUpdate}
            input={formModel.notes}
            multiline={true}
          />
        </Col>
      </Row>
    </BwjGrid>
  );
};
